module.exports = __webpack_public_path__ + "img/bg1.80d04a63.jpg";